































































import { Component, Vue, Ref } from "vue-property-decorator";
import { ClientPanel, getClientPanelName } from "@/data/models/ClientPanel";
import { getAvailablePanels } from "@/data/repository/ClientPanelRepository";
import BaseDialogComponent from "@/components/common/BaseDialog.vue";

import { getDeviceTypeNameFromSerialNumber } from "@/data/models/IresDevice";
import { SearchQueryDebouncer } from "@/utils/SearchQueryDebouncer";
import { ProjectDetails } from "@/data/models/ProjectDetails";
import {
  findBranch,
  getBranchesOfClient,
} from "@/data/repository/ClientRepository";
import { BranchFilter } from "@/data/models/BranchFilter";

@Component({
  components: {
    "base-dialog": BaseDialogComponent,
  },
})
export default class SelectClientPanelComponent extends Vue {
  @Ref("baseDialog")
  baseDialogComponent!: BaseDialogComponent;

  searchQueryDebouncer = new SearchQueryDebouncer(this.onSearchQueryChanged);

  searchQuery = "";

  isLoadingPanels = false;
  showNoPanelsAvailableHint = false;

  onSearchQueryChanged(searchQuery: string) {
    this.searchQuery = searchQuery;
  }

  getBranchName(clientPanel: ClientPanel) {
    const branch = clientPanel.branch;

    if (!branch) {
      return null;
    }

    return this.branchNameLookup.get(branch);
  }

  getDeviceName(clientPanel: ClientPanel) {
    return (
      getDeviceTypeNameFromSerialNumber(this, clientPanel.serialNumber) +
      " " +
      getClientPanelName(clientPanel)
    );
  }

  clientPanels: Array<ClientPanel> = [];

  get clientPanelsToDisplay() {
    const searchQueryLowerCase = this.searchQuery.toLowerCase();

    return this.clientPanels.filter(
      (clientPanel) =>
        clientPanel.serialNumber.toLowerCase() ===
          this.selectedSerialNumber.toLowerCase() ||
        (clientPanel.inventoryNumber
          ?.toLowerCase()
          ?.indexOf(searchQueryLowerCase) ?? -1) >= 0 ||
        this.getDeviceName(clientPanel)
          .toLowerCase()
          .indexOf(searchQueryLowerCase) >= 0
    );
  }

  selectedSerialNumber = "";
  branchNameLookup = new Map<string, string>();

  resolve?: (value: ClientPanel | undefined) => void = undefined;
  reject?: (reason: string) => void = undefined;

  async show(projectDetails: ProjectDetails) {
    this.selectedSerialNumber = "";
    this.searchQuery = "";

    const targetBranchId = projectDetails.clientData.branch;
    let targetBranchFilter: BranchFilter | null = null;

    if (targetBranchId) {
      const branch = findBranch(targetBranchId) ?? null;

      if (branch) {
        targetBranchFilter = new BranchFilter(false, branch);
      }
    }

    getBranchesOfClient().forEach((branch) => {
      this.branchNameLookup.set(branch.branchNumber.toString(), branch.name);
    });

    this.baseDialogComponent.show({
      title: this.$t("assignDevice.assignHyDryDevice").toString(),
      positiveButtonText: this.$t("common.assign").toString(),
      scrollable: true,
    });

    this.isLoadingPanels = true;
    this.clientPanels = (await getAvailablePanels())
      .filter((c) => c.availability !== -1)
      .filter((c) => !c.currentProjectId || c.currentProjectId === "")
      .filter(
        (c) =>
          !targetBranchFilter ||
          targetBranchFilter.doesMatchBranchNumber(c.branch)
      )
      .sort((c1, c2) => c1.serialNumber.localeCompare(c2.serialNumber));

    this.isLoadingPanels = false;

    this.showNoPanelsAvailableHint = this.clientPanels.length === 0;

    return new Promise<ClientPanel | undefined>((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  onSave() {
    const result = this.clientPanels.find(
      (clientPanel) => clientPanel.serialNumber === this.selectedSerialNumber
    );

    this.resolve && this.resolve(result);
  }

  onCancel() {
    this.resolve && this.resolve(undefined);
  }
}
